module.exports = __webpack_public_path__ + "static/media/Bi_Statement.e61df4bd.svg";